import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';

import './header.css';

import logo from '../../logo.png'

export default function Header(){

    const { user, signOut } = useContext(AuthContext);
    const handleClick = (event) => {
        //useContext.signOut()
        //signOut.signOut;
        //signOut.signOut();
        //alert('dd');
        signOut();
      };

    return(
        <div>

            <div class="grid-x grid-padding-x ">
                <div className="small-12 medium-4 large-3 cell"><img src={logo} id='logo'/></div>
                <div className="small-12 medium-8 large-9 cell ">
                    <div className="links-menu">
                        <Link className="btn" to="/dashboard">Home</Link>
                        <Link className="btn" to="/nova-analise">Analise Solo</Link>
                        <Link className="btn" to="/perfil">Perfil</Link>
                        <Link className="btn" to="#" onClick={handleClick}>Sair</Link>
                    </div>
                </div>
            </div>


        </div>
    )
}